import Link from 'next/link';
import MobileMenu from './MobileMenu';

// 2026-07-22: header no longer sticky (user request) — scrolls away with the page like
// normal content, so the scroll-shadow logic (which only existed to react to the sticky
// state) is gone too and this can be a plain server component again.
export default function Header() {
  return (
    <header
      style={{
        background: 'var(--sk-bar, linear-gradient(135deg, #0d47a1 0%, #1565c0 60%, #1976d2 100%))',
        boxShadow: 'var(--sk-bar-shadow, 0 2px 8px rgba(13,71,161,.2))',
      }}
    >
      <div className="max-w-5xl mx-auto px-4 h-[58px] flex items-center justify-center relative" dir="rtl">
        <MobileMenu />
        <Link href="/" className="flex items-center justify-center" aria-label="המומחים — דף הבית">
          <picture>
            <source srcSet="/brand/logo-white.avif" type="image/avif" />
            <source srcSet="/brand/logo-white.webp" type="image/webp" />
            <img
              src="/brand/logo-white.webp"
              alt="המומחים"
              width={227}
              height={38}
              className="h-[30px] sm:h-[38px] w-auto"
              style={{ objectFit: 'contain' }}
              fetchPriority="high"
            />
          </picture>
        </Link>
      </div>
    </header>
  );
}
